import { useAuthenticated } from "nate-react-api-helpers";
import { User } from "../api/Users";

// the auth ping returns the logged-in user (see api.users.ping)
export function useCurrentUser(): User | null {
    return useAuthenticated().lastPingResult;
}
